var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeesbuzz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.049,
    y1: 0.092,
    x2: 0.798,
    y2: 0.923,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#7d95e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f28dd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FeesBuzz",
    transform: "translate(-63 -89)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6093",
    "data-name": "Rectangle 6093",
    width: 24,
    height: 24,
    transform: "translate(63 89)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_7FeesBuzz",
    "data-name": "7FeesBuzz",
    transform: "translate(65.816 91.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M11.81,9.392v-6.5a.538.538,0,0,0-.5-.5,3.777,3.777,0,0,0-1.334.25A7.224,7.224,0,0,0,6.39,5.473a7.826,7.826,0,0,0-.25,8.089,7.4,7.4,0,0,0,7.505,3.252c4.086-.584,5.5-4.253,5.587-7a.481.481,0,0,0-.5-.5H11.81Z",
    transform: "translate(-2.052 -1.2)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M18.9,3.847V1.1c0-.584.167-.751.834-.667a7.08,7.08,0,0,1,6.171,6.088c.083.667-.083.917-.751.917h-5.5c-.5,0-.751-.167-.751-.751Z",
    transform: "translate(-7.562 -0.408)",
    fill: "#18253e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M0,22.844a3.951,3.951,0,0,1,4.086-3.919A4.045,4.045,0,1,1,4,27.014,4.149,4.149,0,0,1,0,22.844Z",
    transform: "translate(0 -7.814)",
    fill: "#33eeb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M6.035,23.152H4.117a.25.25,0,1,1,0-.5h2c0-.083,0-.167-.083-.167a1.046,1.046,0,0,0-.917-.5H4.2c-.083,0-.167-.083-.25-.083-.083-.167,0-.334.25-.334H7.035a.25.25,0,1,1,0,.5H6.285c.083.25.25.5.334.751h.334a.25.25,0,1,1,0,.5H6.535C6.368,24.069,5.7,24.486,4.7,24.4c.083.083.167.083.167.167l1.5,1.5.083.083a.254.254,0,0,1,0,.334c-.083.083-.167.083-.334,0L6.035,26.4c-.667-.667-1.334-1.334-2.085-2-.083-.083-.167-.167-.083-.334s.167-.167.334-.167h.917A.907.907,0,0,0,6.035,23.152Z",
    transform: "translate(-1.533 -8.872)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeesbuzz);
export default __webpack_public_path__ + "static/media/feesbuzz.8e6ab34a0e0b8d7456d9aad6c7bb6a4d.svg";
export { ForwardRef as ReactComponent };